export const FIELD_TYPES = {
  ALIGNMENT: 'alignment',
  TEXT_ALIGNMENT: 'textalignment',
  CHOICE: 'choice',
  LINK: 'link',
  ICON: 'icon',
  IMAGE: 'image'
};
export const TOOL_TYPES = {
  ALIGNMENT: 'alignment',
  SIZE: 'size',
  GAP: 'gap',
  VARIANT: 'variant',
  HEADING_LEVEL: 'heading_level',
  LINK: 'link',
  ICON: 'icon',
  IMAGE: 'image'
};